import { gql } from "@apollo/client";

import CommonFeedbackArtifactFragment from "@graphql/common-feedback-artifact-fragment";

export default gql`
  ${CommonFeedbackArtifactFragment}
  query getNewDashboardFeedbackQuery(
    $asUser: Int
    $fetchData: Boolean!
    $feedbackRecipient: Int
    $feedbackSender: Int
    $feedbackState: FeedbackState
    $createdBetweenDates: [Date]
    $after: String
    $first: Int!
  ) {
    artifacts(
      artifactType: feedback
      feedbackRecipient: $feedbackRecipient
      feedbackSender: $feedbackSender
      feedbackState: $feedbackState
      createdBetweenDates: $createdBetweenDates
      asUser: $asUser
      orderBy: "-created"
      first: $first
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edges @include(if: $fetchData) {
        node {
          id
          ... on FeedbackArtifactNode {
            artifactType
            title
            created
            updated
            creator {
              id
              name
              avatar
            }
            canDelete {
              permission
            }
            canUpdate {
              permission
            }
            ...CommonFeedbackArtifactFragment
          }
        }
      }
    }
  }
`;
